const env = process.env.NODE_ENV;

if (env === "production") {
    if (!process.env.REACT_APP_SERVER_URL) {
        process.env.REACT_APP_SERVER_URL = "https://se.tong.icu/";
    }

    if (!process.env.REACT_APP_SERVER_WS_URL) {
        process.env.REACT_APP_SERVER_WS_URL = "wss://se.tong.icu/";
    }
}

export const SERVER_URL =
    process.env.REACT_APP_SERVER_URL || "http://localhost:13324/";

export const SERVER_WS_URL =
    process.env.REACT_APP_SERVER_WS_URL || "ws://localhost:13324/";
